import { render, staticRenderFns } from "./LeadsTasks.vue?vue&type=template&id=7507948b&"
import script from "./LeadsTasks.vue?vue&type=script&lang=js&"
export * from "./LeadsTasks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports